import { render, staticRenderFns } from "./PageCAE.vue?vue&type=template&id=b48c5966&scoped=true"
import script from "./PageCAE.vue?vue&type=script&lang=js"
export * from "./PageCAE.vue?vue&type=script&lang=js"
import style0 from "./PageCAE.vue?vue&type=style&index=0&id=b48c5966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48c5966",
  null
  
)

export default component.exports